import { render } from "../templates/edit-benefit-conditions.html?vue&type=template&id=c4f3e39c"
import script from "./edit-benefit-conditions.vue?vue&type=script&lang=js"
export * from "./edit-benefit-conditions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__